import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { VideoControlButton } from './VideoControlButton'
import { tID } from '../../utils/utils'
import { VideoIcon } from '../icons/VideoIcon'

export type CameraVideoControlButtonProps = {
  disabled: boolean
  onPress: () => void
  enabledColor?: string
  disabledColor?: string
  iconColor?: string
  size?: number
}

export const CameraVideoControlButton: FunctionComponent<CameraVideoControlButtonProps> = ({
  disabled,
  enabledColor,
  disabledColor,
  iconColor,
  onPress,
  size = 64,
}) => {
  const { formatMessage } = useIntl()
  const { colors } = useTheme()
  const { videoControlButton } = colors.components
  const iconSize = size / 2.6

  return (
    <VideoControlButton
      enabledColor={enabledColor || videoControlButton.enabledColor.fill}
      enabledIcon={<VideoIcon fillColor={iconColor || colors.iconInverse} isFilled size={iconSize} />}
      disabledColor={disabledColor || videoControlButton.disabledColor.fill}
      disabledIcon={<VideoIcon fillColor={iconColor || colors.iconInverse} isFilled size={iconSize} isMuted />}
      onPress={onPress}
      disabled={disabled}
      testID={tID('camera')}
      size={size}
      accessibilityLabel={formatMessage(
        {
          defaultMessage: 'Video is {enabled , select, true {enabled} other {disabled}}',
          description: 'Video icon button that displays if the video is on or not',
        },
        {
          enabled: !disabled,
        },
      )}
    />
  )
}
